import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import * as $ from 'jquery';
import {
  faConnectdevelop,
  faGgCircle,
} from '@fortawesome/free-brands-svg-icons';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { AppService } from '../shared/services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { UserManagementService } from '../shared/services/user-management.service';

import { Pipe, PipeTransform } from '@angular/core';
import {
  faArrowAltCircleRight,
  faCheckCircle,
  faCircle,
  faMinus,
  faPlus,

} from '@fortawesome/free-solid-svg-icons';
import {
  faDotCircle,
} from '@fortawesome/free-regular-svg-icons';
declare var $: any;
import { Config } from '../config';
import { TaskPlannerComponent } from '../task-planner/task-planner.component';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-entity-test-coverage',
  templateUrl: './entity-test-coverage.component.html',
  styleUrls: ['./entity-test-coverage.component.scss']
})
export class EntityTestCoverageComponent implements OnInit {
  mapText: any = '';
  newscenariolevel: any = '';
  persona: any = [];
  attribute: any = [];
  interaction: any = [];
  modelData: any;
  config: any;
  activeSmartChecklist: any = '';
  constructor(
    public translate: TranslateService,
    private router: Router,
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private AppService: AppService,
    private cookieService: CookieService,
    private userManagementService: UserManagementService,
    private Config: Config,
  ) { }

  ngOnInit(): void {
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    // this.constructEntityMapText(this.mapText);
    var selectedEUT = window.localStorage.getItem("entityTestName");
    if (!selectedEUT) {
      window.localStorage.removeItem("mapTextCoverage");
    }
    setInterval(() => {
      this.constructEntityMapText();
      var activeChecklist = window.localStorage.getItem("entityTestChecklist");
      if(activeChecklist){
        this.activeSmartChecklist = 'la';
      }else{
        this.activeSmartChecklist = '';
      }
      
    }, 2000);
  }

  //contruct a string that contain the peronas mapped, attributes mapped and the interaction with other euts
  constructEntityMapText() {
    // console.log(maptext);
    // alert("A");
    this.mapText = '';
    $('#entityCoverage').empty();
    this.mapText = window.localStorage.getItem("mapTextCoverage");
    $('#entityCoverage').append(this.mapText);
    // console.log("this.mapText",this.mapText);
  }
}
